import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useRouter } from "next/router";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { ContactSupport, Home, Menu, ShoppingCartOutlined, Store } from "@mui/icons-material";
import { Badge } from "@mui/material";
import { getUrlIcon } from "@common/utils/iconUtils";

import useShopContext from "@hooks/useShopContext";

const PREFIX = "FloatingMenu";

const classes = {
  badgeOffset: `${PREFIX}-badgeOffset`,
};

const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: "fixed",
  "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
    top: theme.spacing(2),
    right: theme.spacing(2),
  },

  [`& .${classes.badgeOffset}`]: {
    top: -5,
    right: -5,
  },
}));

const FloatingMenu = ({ ...props }) => {
  const router = useRouter();
  const { shop } = useShopContext();

  const links = shop?.shop_settings?.links || [];

  const [open, setOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    setCartItems(
      localStorage.getItem("cart_items") ? JSON.parse(localStorage.getItem("cart_items")) : [],
    );
  }, []);

  return (
    <StyledSpeedDial
      ariaLabel="SpeedDial openIcon example"
      icon={
        <Badge
          classes={{ anchorOriginTopRightRectangular: classes.badgeOffset }}
          badgeContent={cartItems.length}
          color="error"
        >
          <SpeedDialIcon icon={<Menu />} />
        </Badge>
      }
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      FabProps={{ color: "secondary", size: "medium" }}
      {...props}
    >
      {shop && shop.use_welcome_page && (
        <SpeedDialAction
          key="Home"
          icon={<Home />}
          tooltipTitle="Home"
          onClick={() => router.push("/")}
        />
      )}
      <SpeedDialAction
        key="Products"
        icon={<Store />}
        tooltipTitle="Products"
        onClick={() => router.push("/products")}
      />
      <SpeedDialAction
        key="Cart"
        icon={
          cartItems?.length > 0 ? (
            <Badge badgeContent={cartItems.length} color="error">
              <ShoppingCartOutlined />
            </Badge>
          ) : (
            <ShoppingCartOutlined />
          )
        }
        tooltipTitle="Cart"
        onClick={() => router.push("/cart")}
      />
      {shop?.shop_settings?.faqs?.length > 0 && (
        <SpeedDialAction
          key="FAQ"
          icon={<ContactSupport />}
          tooltipTitle="FAQ"
          onClick={() => router.push("/faq")}
        />
      )}
      {links.map((link, index) => (
        <SpeedDialAction
          key={`social-${index}`}
          icon={getUrlIcon(link)}
          tooltipTitle="Social Link"
          FabProps={{
            href: link,
            target: "_blank",
            rel: "noopener noreferrer",
          }}
        />
      ))}
    </StyledSpeedDial>
  );
};

export default FloatingMenu;
